import { Circle } from 'react-konva';
import React, { useEffect, useRef, useState } from 'react';
import type { Circle as CircleType, CircleConfig } from 'konva/types/shapes/Circle';
import { noop } from 'utils/fp';

interface PolygonHandleProps extends CircleConfig {
  /**
   * Allow this point to be grabbable
   */
  grabbable?: boolean;
}

/**
 * A circle on a polygon point that a user can interact with
 */
export const PolygonHandle = ({ id, stroke, grabbable = true, onMouseDown = noop, onMouseUp = noop, ...props }: PolygonHandleProps): JSX.Element => {
  const [filled, setFilled] = useState(false);
  const fill = filled ? stroke : 'white';
  const nodeRef = useRef<CircleType>(null);
  const [isGrabbed, setIsGrabbed] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  // change mouse style
  useEffect(() => {
    const style = nodeRef.current?.getStage()?.container().style;
    if (grabbable && style) {
      if (isHovering && isGrabbed) {
        style.cursor = 'grabbing';
      } else if (isHovering) {
        style.cursor = 'grab';
      } else {
        style.cursor = '';
      }
    }
  }, [isGrabbed, isHovering]);

  return (
    <Circle
      id={id}
      ref={nodeRef}
      onMouseEnter={() => {
        setFilled(true);
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setFilled(false);
        setIsHovering(false);
      }}
      {...props}
      onMouseDown={(e) => {
        e.cancelBubble = true;
        setIsGrabbed(true);
        onMouseDown(e);
      }}
      onMouseUp={(e) => {
        e.cancelBubble = true;
        setIsGrabbed(false);
        onMouseUp(e);
      }}
      {...props}
      fill={fill}
      shadowBlur={2}
    />
  );
};
